const lowercasedExceptions = [
  'A',
  'An',
  'The',
  'And',
  'But',
  'Or',
  'For',
  'Nor',
  'As',
  'At',
  'By',
  'For',
  'From',
  'In',
  'Into',
  'Near',
  'Of',
  'On',
  'Onto',
  'To',
  'With',
];
const shouldBeLowercased = new RegExp(
  `^(?:${lowercasedExceptions.join('|')})$`,
  'i'
);
export const capitalize = (word: string) => {
  if (!word || typeof word !== 'string') return '';
  return shouldBeLowercased.test(word)
    ? word
    : `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
};

export const titleCase = (sentence: string) =>
  sentence
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ');
